import React, { Component } from 'react';
import { DatePicker } from 'antd';
import ComponentWrapper from './ComponentWrapper';
import { dateRangeMap, dateRangeNoTimeMap } from './componentMappers';
import PropTypes from 'prop-types';

const { RangePicker } = DatePicker;

export default class DateRangeField extends Component {
  static propTypes = {
    useTime: PropTypes.bool,
  };

  static defaultProps = {
    useTime: true,
  };

  render() {
    const mapProps = this.props.useTime ? dateRangeMap : dateRangeNoTimeMap;
    return (
      <ComponentWrapper
        {...this.props}
        mapProps={mapProps}
        render={(props) => {
          // Extract onBlur/onFocus so they are only triggered via onOpenChange
          // (when the picker truly opens/closes), not via native input focus events.
          // Without this, clicking the calendar panel blurs the input, causing
          // react-final-form to mark the field as inactive while still picking a date.
          const { onBlur, onFocus, ...restProps } = props;
          return (
            <RangePicker
              {...restProps}
              onOpenChange={(status) => {
                status ? onFocus?.() : onBlur?.();
              }}
            />
          );
        }}
      />
    );
  }
}
